import React from "react";
import Headline from "../common/Headline";
import styled from "styled-components";
import Content from "../common/Content";
import { bottomMargins, colors, spacing } from "../theme";
import Paragraph from "../common/Paragraph";
import { Media, MediaRef } from "../../lib/CmsApi";
import Slider from "../Slider";
import Section from "../sections/Section";
import { Image } from "../../lib/image";
import { responsiveBackgroundImage } from "../../lib/responsiveImage";
import getImageFocus from "../../lib/getImageFocus";

const PromotionHeadline = styled(Headline)`
  ${spacing("margin-bottom", 80)}
`;

interface StepProps {
  image: MediaRef & Media;
  title: string;
  text: string;
}

const Step = ({ title, image, text }: StepProps) => (
  <StyledStep>
    <StepImage image={image} />
    <StepTitle size={5} bold level={3}>
      {title}
    </StepTitle>
    <StepText tiny>{text}</StepText>
  </StyledStep>
);

const StyledStep = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
`;

const StepImage = styled.div<{ image: Image }>`
  ${({ image }) =>
    responsiveBackgroundImage({
      image,
      sizes: {
        0: 300
      }
    })}
  background-repeat: no-repeat;
  background-size: cover;
  background-position: ${({ image }) => getImageFocus(image)};
  border-radius: 100%;
  width: 80%;
  padding-bottom: 80%;
  max-width: 100%;
  ${bottomMargins.small}
`;

const StepTitle = styled(Headline)`
  color: ${colors.darkgrey};
  text-align: center;
`;

const StepText = styled(Paragraph)`
  text-align: center;
  margin-bottom: 0;
`;

interface Props {
  headline: string;
  steps: StepProps[];
}
export default function PromotionSteps(p: Props) {
  return (
    <Section color={colors.pigeonSuperLight} inline>
      <Content padded leftIndented>
        <PromotionHeadline size={4} bold grey level={2}>
          {p.headline}
        </PromotionHeadline>
        <Slider
          itemCountXLarge={3}
          itemCountLarge={3}
          itemCountMedium={2}
          itemCountSmall={1}
          ariaLabel={p.headline}
        >
          {p.steps.map((s, idx) => (
            <Step {...s} key={idx} />
          ))}
        </Slider>
      </Content>
    </Section>
  );
}

PromotionSteps.getImages = (p: Props) => {
  return p.steps.map(s => s.image);
};
